/**
 * cm-footer.js — footer unit scripts.
 * Purpose: footer accordions + language submit + later the bottom bar and WhatsApp float.
 * Public API: none.
 * Events: none.
 */
(function () {
  'use strict';
  if (window.__cmFooterLoaded) return;
  window.__cmFooterLoaded = true;

  /* === FOOTER (ftr-3) === */

  // Mobile accordion columns: toggle .is-open + aria-expanded.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cm-footer-toggle]');
    if (!btn) return;
    var col = btn.closest('[data-cm-footer-col]');
    if (!col) return;
    var open = col.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Language selector: submit the localization form on change.
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-cm-lang-select]');
    if (!select) return;
    var form = select.closest('form');
    if (form) form.submit();
  });

  // Open the column that holds a server-rendered newsletter message (native post fallback).
  function openMessageColumns() {
    var cols = document.querySelectorAll('[data-cm-footer-col]');
    for (var i = 0; i < cols.length; i += 1) {
      var col = cols[i];
      if (!col.querySelector('.cm-footer__msg')) continue;
      col.classList.add('is-open');
      var toggle = col.querySelector('[data-cm-footer-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var form = col.querySelector('form');
      if (form && window.location.hash === '#' + form.id && form.scrollIntoView) {
        form.scrollIntoView({ block: 'center' });
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openMessageColumns);
  } else {
    openMessageColumns();
  }
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('[data-cm-footer]')) openMessageColumns(); });

  /* === BAR + WHATSAPP (ftr-7) === */

  // Run once the CM foundation exists (this file loads with defer, but the
  // foundation may initialise on DOMContentLoaded).
  function whenCM(fn) {
    if (window.CM) fn();
    else document.addEventListener('DOMContentLoaded', function () {
      if (window.CM) fn();
    });
  }

  whenCM(function () {
    // Cart count badges: keep every [data-cm-bar-count] in sync (bottom bar).
    // B20: renamed (old attribute was the header's) — cm-header.js keeps
    // writing the header badge; the bar badge is ours alone.
    var countEls = function () {
      return document.querySelectorAll('[data-cm-bar-count]');
    };
    function setCount(n) {
      n = Number(n) || 0;
      countEls().forEach(function (el) {
        el.textContent = n > 99 ? '99+' : String(n);
        el.hidden = n < 1;
      });
    }
    var refreshTimer = null;
    function refresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        CM.cart.get().catch(function () {});
      }, 50);
    }
    CM.on('cart:get', function (c) {
      if (c && typeof c.item_count === 'number') setCount(c.item_count);
    });
    CM.on('cart:updated', function (d) {
      if (d && d.cart && typeof d.cart.item_count === 'number') setCount(d.cart.item_count);
      else refresh();
    });
    ['cart:add', 'cart:change'].forEach(function (name) {
      CM.on(name, function (d) {
        if (d && typeof d.item_count === 'number') setCount(d.item_count);
        else refresh();
      });
    });

    // Cart tab: open the cart drawer/modal; if no overlay took over, go to the
    // cart page (graceful fallback).
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-cm-cart-open]');
      if (!tab) return;
      if (e.defaultPrevented) return;
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var fallback = setTimeout(function () {
        if (!document.querySelector('cm-drawer[open], cm-modal[open]') && !document.body.classList.contains('drawer-open')) {
          window.location.href = tab.href;
        }
        offs.forEach(function (off) { if (typeof off === 'function') off(); });
      }, 1200);
      var offs = [];
      ['drawer:open', 'modal:open'].forEach(function (name) {
        offs.push(CM.on(name, function () {
          clearTimeout(fallback);
          offs.forEach(function (off) {
            if (typeof off === 'function') off();
          });
        }));
      });
      CM.emit('cart:open');
    });

    // WhatsApp links (desktop float + mobile bar tab): append the selected
    // variant title to the prefilled message.
    CM.on('variant:changed', function (d) {
      var links = document.querySelectorAll('[data-cm-wa]');
      if (!links.length) return;
      var v = d && d.variant;
      var extra = (v && v.title && v.title !== 'Default Title') ? ' (' + v.title + ')' : '';
      links.forEach(function (a) {
        var base = a.getAttribute('data-cm-wa-base') || '';
        a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?text=' + encodeURIComponent(base + extra));
      });
    });
  });

  /* === FIDELITY RESET (fid-f1): newsletter pre-validation, back-to-top, ripple === */

  // Newsletter: 500ms-debounced email check (Jlood @input.debounce.500ms) —
  // disables the submit until the address is valid and shows an inline error.
  // Server-side messages stay authoritative; this only mirrors Jlood's UX.
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-cm-newsletter-input]');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-cm-newsletter-error]');
    clearTimeout(input.__cmDebounce);
    input.__cmDebounce = setTimeout(function () {
      var value = input.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (btn) btn.disabled = !valid;
      if (msg) msg.hidden = valid || value === '';
    }, 500);
  });

  // Back-to-top: same thresholds as Jlood (300px below 1025px viewport,
  // 900px above), 500ms fade+rise handled in CSS via .is-visible.
  (function () {
    var ticking = false;
    function threshold() {
      return window.innerWidth < 1025 ? 300 : 900;
    }
    function update() {
      ticking = false;
      var btn = document.querySelector('[data-cm-top]');
      if (!btn) return;
      var top = document.body.scrollTop || document.documentElement.scrollTop;
      btn.classList.toggle('is-visible', top > threshold());
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', function () {
      update();
    }, { passive: true });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-cm-top]')) update();
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cm-top]');
      if (!btn) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }
  })();

  // Button ripple (Jlood CustomButton): mouse position feeds --cm-btn-x/y so
  // the CSS ::before ripple grows from the pointer. Desktop pointers only.
  if (window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1024px)').matches) {
    document.addEventListener('pointermove', function (e) {
      var btn = e.target.closest && e.target.closest('.cm-footer .cm-btn');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      btn.style.setProperty('--cm-btn-x', (((e.clientX - rect.left) / rect.width) * 100).toFixed(1) + '%');
      btn.style.setProperty('--cm-btn-y', (((e.clientY - rect.top) / rect.height) * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* === BAR + WHATSAPP (ftr-7 inserts above this line) === */
})();
